import { render, staticRenderFns } from "./botKeywordRecommend.vue?vue&type=template&id=626fafb1&scoped=true"
import script from "./botKeywordRecommend.vue?vue&type=script&lang=js"
export * from "./botKeywordRecommend.vue?vue&type=script&lang=js"
import style0 from "./botKeywordRecommend.vue?vue&type=style&index=0&id=626fafb1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626fafb1",
  null
  
)

export default component.exports